import { Suspense } from 'react'
import { ErrorBoundary } from '@sentry/react'

import { useAndConsumeSearchParam } from '@jotta/router'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import { EntryLayout } from '../components/Layout/EntryLayout'

import { DeviceLogin } from './DeviceLogin'

export function DeviceLoginRoute() {
  const code = useAndConsumeSearchParam('code')
  // TODO should ErrorBoundary+Suspense be included in AppLayoutSignup?
  return (
    <EntryLayout>
      <ErrorBoundary
        fallback={({ error, resetError }) => (
          <ErrorPage error={error} resetError={resetError} />
        )}
      >
        <Suspense fallback={<LoadingOverlay id="DeviceLoginRoute" open />}>
          <DeviceLogin code={code} />
        </Suspense>
      </ErrorBoundary>
    </EntryLayout>
  )
}
